import React from "react";

const AppContext = React.createContext(["auth", () => {}]);

export default AppContext;
